<template><!-- Generator: Adobe Illustrator 26.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
<g>
	<defs>
		<rect id="SVGID_1_" y="0" width="100" height="100"/>
	</defs>
	<clipPath id="SVGID_00000029741829810099278360000012215504580844341672_">
		<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
	</clipPath>
	<g style="clip-path:url(#SVGID_00000029741829810099278360000012215504580844341672_);">
		<path class="st2" style="fill-rule:evenodd;clip-rule:evenodd;" fill="currentColor" d="M6.3,45.8c-4.7-8.1-2-18.5,6.1-23.3L34.6,9.6c8.1-4.7,18.5-2,23.3,6.1l25.3,43.3c4.7,8.1,2,18.5-6.1,23.3
			L54.9,95.1c-8.1,4.7-18.5,2-23.3-6.1L6.3,45.8z M20.5,48.9l33.7-19.5l3.5,6L23.9,54.9L20.5,48.9z M52.3,44.7L26.7,59.5l3.5,6
			l25.6-14.8L52.3,44.7z M33.7,70.5L53.6,59l3.5,6L37.2,76.5L33.7,70.5z M48.2,17.6L13.9,37.4l3.5,6l34.3-19.8L48.2,17.6z
			 M100.2,6.2L90.1,0L61.7,46.4l10.1,6.2L100.2,6.2z M60.7,48.5l-0.9,12.3L70.7,54L60.7,48.5z"/>
	</g>
</g>
</svg>
</template>